module.exports = __webpack_public_path__ + "img/ski4.cf38bab1.jpg";